var hcMainDefault = new Swiper ('.hc-main-slider-default', {
  direction: 'horizontal',
  loop: false,
  slidesPerView: 1,
  slidesPerScroll: 1,
  speed: 600,
  centeredSlides: true,
  autoHeight: true,
  pagination: {
    el: ".swiper-pagination",
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  effect: 'fade',
    fadeEffect: {
      crossFade: true
  },
});


var hcVariants = $(".hc-main-slider-default").attr('data-variants');
if(hcVariants != '1'){
  var hcMainSlidesDef = [];
  $(".hc-main-slider-default .swiper-slide").each(function(){
    hcMainSlidesDef.push($(this));
  });
  
  var hcValue = $('.hc-main-slider-default').attr('data-value');
  $(hcMainSlidesDef).each(function () {
    if($(this).hasClass('hc-'+hcValue)){          
      hcMainDefault.appendSlide(this);
    } else {
      jQuery(this).remove();
    }
  });
  
  hcMainDefault.update();
  hcMainDefault.slideTo(0, false);
}

$('.hc-main-slider-default').removeClass('hc-loading');